import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, Unique, UpdateDateColumn, VersionColumn } from "typeorm";
import { AntibioticsTestStatus, PackageTypeEnum, PassOrFail, PlantsEnum, QualityTypeEnum, SupplierTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { Indent } from "./indent.entity";
@Entity("indent_items")
export class IndentItems {
    @PrimaryGeneratedColumn("increment", { name: 'indent_item_id' })
    indentItemId: number;
    @Column("int", {
        nullable: false,
        name: "indent_id",
    })
    indentId: number;
    @Column("int", {
        nullable: true,
        name: "broker",
        default: 0,
    })
    broker: number;

    @Column("int", {
        nullable: true,
        name: "farmer",
        default:0
    })
    farmer: number;

    @Column("int", {
        nullable: true,
        name: "farmer_code"
    })
    farmerCode: number;

    @Column("int", {
        nullable: false,
        name: "product"
    })
    product: number;

    @Column("int", {
        nullable: true,
        name: "expected_count"
    })
    expectedCount: number;

    @Column("int", {
        nullable: false,
        name: "expected_qty"
    })
    expectedQty: number;

    @Column("int", {
        nullable: true,
        name: "expected_price"
    })
    expectedPrice: number;

    @Column("int", {
        nullable: true,
        name: "expected_count2"
    })
    expectedCount2: number;

    @Column("int", {
        nullable: true,
        name: "expected_price2"
    })
    expectedPrice2: number;

    @Column("int", {
        nullable: true,
        name: "expected_count3"
    })
    expectedCount3: number;

    @Column("int", {
        nullable: true,
        name: "expected_price3"
    })
    expectedPrice3: number;

    @Column("int", {
        nullable: true,
        default: 0,
        name: "harvest_report_id"
    })
    harvestReportId: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("int", {
        nullable: true,
        name: "expected_price4"
    })
    expectedPrice4: number;

    @Column("int", {
        nullable: true,
        name: "expected_count4"
    })
    expectedCount4: number;

    @Column("int", {
        nullable: true,
        name: "rm_rate"
    })
    rmRate: number;

    @Column("int", {
        nullable: true,
        name: "ice_rate"
    })
    iceRate: number;

    @Column("varchar", {
            nullable: true,
            length: 50,
            name: "test_result"
        })
        testResult: PassOrFail;
    
    @Column({
        type:'enum',
        enum: AntibioticsTestStatus, 
        name: 'antibiotics_test_status',
        nullable:false,
        default:AntibioticsTestStatus.PENDING,
    })
    antibioticsTestStatus: AntibioticsTestStatus; 

    

@Column('enum',{
        name:'quality',
        enum:QualityTypeEnum,
        nullable:false
    })
    quality : QualityTypeEnum

@Column({
  type: "enum",
  enum: PackageTypeEnum,
  nullable: true,
  name: "package_type"
})
packageType: PackageTypeEnum;

@Column("decimal", {
  nullable: true,
  precision: 10,
  scale: 2,
  name: "gross_weight"
})
grossWeight: number;

@Column("decimal", {
  nullable: true,
  precision: 10,
  scale: 2,
  name: "tare_weight"
})
tareWeight: number;



    @ManyToOne(type => Indent, indent => indent.indentItemsInfo, { nullable: false, })
    @JoinColumn({ name: "indent_id" })
    indentInfo: Indent;
}

